/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateTankTypeRequest model module.
* @module model/CreateTankTypeRequest
* @version 2020-12-7
*/
export default class CreateTankTypeRequest {
    /**
    * Constructs a new <code>CreateTankTypeRequest</code>.
    * タンクタイプ登録リクエスト
    * @alias module:model/CreateTankTypeRequest
    * @class
    * @param tankTypeCode {String} タンクタイプコード
    * @param tankName {String} タンク名
    * @param makerName {String} メーカー名
    * @param oilMaxVolume {Number} 最大容量
    * @param tankMaxVolume {Number} 法定容量
    * @param oilVolumeRate {Number} オイル係数
    * @param tankWidth {Number} タンク幅
    * @param tankDepth {Number} タンク奥行き
    * @param tankHeight {Number} タンク高さ
    */

    constructor(tankTypeCode, tankName, makerName, oilMaxVolume, tankMaxVolume, oilVolumeRate, tankWidth, tankDepth, tankHeight) {
        
        
        this['tankTypeCode'] = tankTypeCode;
        this['tankName'] = tankName;
        this['makerName'] = makerName;
        this['oilMaxVolume'] = oilMaxVolume;
        this['tankMaxVolume'] = tankMaxVolume;
        this['oilVolumeRate'] = oilVolumeRate;
        this['tankWidth'] = tankWidth;
        this['tankDepth'] = tankDepth;
        this['tankHeight'] = tankHeight;
        
    }

    /**
    * Constructs a <code>CreateTankTypeRequest</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateTankTypeRequest} obj Optional instance to populate.
    * @return {module:model/CreateTankTypeRequest} The populated <code>CreateTankTypeRequest</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateTankTypeRequest();
                        
            
            if (data.hasOwnProperty('tankTypeCode')) {
                obj['tankTypeCode'] = ApiClient.convertToType(data['tankTypeCode'], 'String');
            }
            if (data.hasOwnProperty('tankName')) {
                obj['tankName'] = ApiClient.convertToType(data['tankName'], 'String');
            }
            if (data.hasOwnProperty('makerName')) {
                obj['makerName'] = ApiClient.convertToType(data['makerName'], 'String');
            }
            if (data.hasOwnProperty('oilMaxVolume')) {
                obj['oilMaxVolume'] = ApiClient.convertToType(data['oilMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('tankMaxVolume')) {
                obj['tankMaxVolume'] = ApiClient.convertToType(data['tankMaxVolume'], 'Number');
            }
            if (data.hasOwnProperty('oilVolumeRate')) {
                obj['oilVolumeRate'] = ApiClient.convertToType(data['oilVolumeRate'], 'Number');
            }
            if (data.hasOwnProperty('tankWidth')) {
                obj['tankWidth'] = ApiClient.convertToType(data['tankWidth'], 'Number');
            }
            if (data.hasOwnProperty('tankDepth')) {
                obj['tankDepth'] = ApiClient.convertToType(data['tankDepth'], 'Number');
            }
            if (data.hasOwnProperty('tankHeight')) {
                obj['tankHeight'] = ApiClient.convertToType(data['tankHeight'], 'Number');
            }
            if (data.hasOwnProperty('remarks')) {
                obj['remarks'] = ApiClient.convertToType(data['remarks'], 'String');
            }
        }
        return obj;
    }

    /**
    * タンクタイプコード
    * @member {String} tankTypeCode
    */
    'tankTypeCode' = undefined;
    /**
    * タンク名
    * @member {String} tankName
    */
    'tankName' = undefined;
    /**
    * メーカー名
    * @member {String} makerName
    */
    'makerName' = undefined;
    /**
    * 最大容量
    * @member {Number} oilMaxVolume
    */
    'oilMaxVolume' = undefined;
    /**
    * 法定容量
    * @member {Number} tankMaxVolume
    */
    'tankMaxVolume' = undefined;
    /**
    * オイル係数
    * @member {Number} oilVolumeRate
    */
    'oilVolumeRate' = undefined;
    /**
    * タンク幅
    * @member {Number} tankWidth
    */
    'tankWidth' = undefined;
    /**
    * タンク奥行き
    * @member {Number} tankDepth
    */
    'tankDepth' = undefined;
    /**
    * タンク高さ
    * @member {Number} tankHeight
    */
    'tankHeight' = undefined;
    /**
    * 備考
    * @member {String} remarks
    */
    'remarks' = undefined;




}
